var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.929,
    height: 92.956,
    viewBox: "0 0 92.929 92.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff005d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    "data-name": "Caminho 543",
    d: "M0,86.42V6.581c.076-.221.167-.438.227-.664A7.7,7.7,0,0,1,7,.1C8.65-.034,10.321.052,11.984.052c2.276,0,3.477,1.186,3.486,3.451.011,2.631,0,5.26,0,7.89v.977h61.98V11.348c0-2.721-.016-5.442.009-8.162A2.908,2.908,0,0,1,80.08.108a33.9,33.9,0,0,1,6.155.061c4.108.536,6.687,3.762,6.688,8.043q0,37.093,0,74.185c0,1,.016,2-.008,2.993A7.751,7.751,0,0,1,87.767,92.5c-.509.179-1.038.3-1.556.454H6.715c-.228-.065-.454-.135-.684-.195a7.715,7.715,0,0,1-5.673-5.25C.235,87.147.119,86.783,0,86.42ZM77.452,15.586H15.473V76.95c0,2.453-1.169,3.622-3.6,3.633-1.482.005-2.966-.035-4.444.035a4.674,4.674,0,0,0-4.09,3.24,4.38,4.38,0,0,0,1.3,4.785,5.013,5.013,0,0,0,3.679,1.23Q41.659,89.854,75,89.864c3.387,0,6.775.023,10.161-.008a4.648,4.648,0,0,0,4.671-4.58,4.754,4.754,0,0,0-4.6-4.677c-1.3-.04-2.6-.013-3.9-.015-2.812,0-3.871-1.069-3.871-3.9V15.588ZM3.092,79.158c2.9-2.295,6.138-1.492,9.231-1.718V3.141H8.393c-3.475,0-5.3,1.832-5.3,5.32v70.7Zm77.523-76v74.3c3.142.179,6.379-.558,9.219,1.67V8.426c0-.3.008-.6-.012-.906a4.594,4.594,0,0,0-4.236-4.342c-1.623-.1-3.258-.02-4.969-.02Z",
    transform: "translate(0 0.002)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    "data-name": "Caminho 544",
    d: "M172.9,156.518c.489,1.858,1.087,3.635,1.4,5.461a26.786,26.786,0,0,1,.64,6.36c-.286,4.064-3.968,6.909-8.162,6.675a7.605,7.605,0,0,1-7.141-7.537,34.376,34.376,0,0,1,1.956-10.013c.092-.279.181-.558.328-1.009a12.332,12.332,0,0,0-4.414,18.591c1.375,1.859,1.3,3.238-.338,4.883q-2.948,2.952-5.9,5.9c-1.718,1.7-3.575,1.611-5.15-.239-13.762-16.151-4.995-41.25,15.856-45.4a27.824,27.824,0,0,1,32.988,23.764,27.167,27.167,0,0,1-6.346,21.605c-1.587,1.92-3.453,1.982-5.208.231q-2.92-2.916-5.833-5.842c-1.694-1.7-1.784-3.026-.345-4.941a12.336,12.336,0,0,0-3.513-18.047c-.255-.152-.522-.283-.821-.444Zm13.042,27.358c8.469-9.465,8.01-23.873.087-32.5l-6.524,6.554a15.574,15.574,0,0,1-.065,19.332l6.5,6.619Zm-37.18-32.566c-8.417,9.106-8.055,23.9-.012,32.474l6.456-6.524c-4.52-6.5-4.5-13.014.015-19.462Zm2.385-2.417,6.316,6.379c1.84-.85,3.641-1.668,5.424-2.523a1.287,1.287,0,0,0,.564-.624c.372-.89.665-1.815,1.034-2.706a3.068,3.068,0,0,1,5.741-.005c.358.864.648,1.756.994,2.625a1.194,1.194,0,0,0,.437.632c1.86.893,3.739,1.747,5.6,2.608l6.351-6.342c-8.874-8.214-23.615-8.213-32.464-.043Zm16.236,1.672c-.168.376-.236.5-.281.634-.951,2.766-2.018,5.5-2.812,8.31a47.493,47.493,0,0,0-1.528,7.425,4.645,4.645,0,0,0,5.521,5.138,4.8,4.8,0,0,0,3.686-5.38c-.55-5.56-2.633-10.686-4.584-16.128Z",
    transform: "translate(-120.891 -121.045)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_545",
    "data-name": "Caminho 545",
    d: "M207.778,526.345H188.361a6.616,6.616,0,0,1-.906-.023,1.538,1.538,0,0,1-.056-3.034,5.376,5.376,0,0,1,.9-.032H227.32a5.544,5.544,0,0,1,.816.023,1.539,1.539,0,0,1-.033,3.049,7.323,7.323,0,0,1-.906.019H207.779Z",
    transform: "translate(-161.334 -453.524)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_546",
    "data-name": "Caminho 546",
    d: "M201.295,619.183c-4.232,0-8.466.008-12.7-.012a1.978,1.978,0,0,1-1.274-.284,2.106,2.106,0,0,1-.621-1.456c.04-.429.528-.884.926-1.186a1.91,1.91,0,0,1,1.051-.153q12.607-.01,25.215-.005c.181,0,.364-.008.544.007a1.585,1.585,0,0,1,1.584,1.547,1.536,1.536,0,0,1-1.666,1.532c-3.567.017-7.135.009-10.7.009h-2.359Z",
    transform: "translate(-161.818 -533.985)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    d: "M359.544,572.754q-4.439,0-8.878,0c-1.239,0-1.938-.554-1.947-1.519s.718-1.568,1.915-1.57q8.923-.008,17.846,0c1.215,0,1.9.594,1.888,1.583-.016.954-.677,1.5-1.856,1.506q-4.483.01-8.968,0Z",
    transform: "translate(-302.249 -493.748)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    d: "M195.374,572.741c-2.449,0-4.9.005-7.348,0-1.187,0-1.847-.542-1.87-1.5-.023-.994.664-1.592,1.879-1.594q7.394-.01,14.786,0c1.143,0,1.863.594,1.89,1.512.028.962-.7,1.572-1.9,1.575-2.48.007-4.959,0-7.438,0Z",
    transform: "translate(-161.349 -493.736)",
    fill: "url(#linear-gradient-6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerformance);
export default __webpack_public_path__ + "static/media/icon-performance.70c09c8e14281c351c59b5b2f633bd0f.svg";
export { ForwardRef as ReactComponent };